import React, { ReactNode, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { Input, InputPassword, Tooltip } from '@xsolla/ui-core';
import { Copy } from '@xsolla/ui-icons';

import { SpaceBetweenBlock } from '../../../styled';
import {
  CopyInputWrapper,
  CopyTooltip,
  ExtraInputButton,
  InputTitle,
  TooltipContent
} from './style';

type Props = {
  value: ReactNode;
  type?: 'text' | 'password';
  title: ReactNode;
  extra?: ReactNode;
  extraCopyHandle?: () => void;
  dataTestId?: string;
};

const CopyHiddenInput = ({
  value,
  title,
  extra,
  type = 'password',
  extraCopyHandle,
  dataTestId
}: Props): JSX.Element => {
  const [copiedStatus, setCopiedStatus] = useState<boolean>(false);

  const copyHandle = () => {
    setCopiedStatus(true);
    extraCopyHandle?.();
    setTimeout(setCopiedStatus, 2000, false);
  };

  return (
    <div>
      <SpaceBetweenBlock>
        <InputTitle>{title}</InputTitle>
        {extra && <div>{extra}</div>}
      </SpaceBetweenBlock>
      <CopyInputWrapper>
        {type === 'password' ? (
          <InputPassword
            value={value as string | number | readonly string[] | undefined}
            readOnly
            data-test-id={dataTestId}
            spellCheck={false}
          />
        ) : (
          <Input
            value={value as string | number | readonly string[] | undefined}
            readOnly
            data-test-id={dataTestId}
            spellCheck={false}
          />
        )}
        <CopyToClipboard text={value as string}>
          <ExtraInputButton
            type="button"
            palette="muted"
            onClick={copyHandle}
            data-test-id={`${dataTestId}-copy`}>
            <>
              <Copy />
              {copiedStatus && (
                <CopyTooltip>
                  <Tooltip controlledVisible content="Copied">
                    <TooltipContent />
                  </Tooltip>
                </CopyTooltip>
              )}
            </>
          </ExtraInputButton>
        </CopyToClipboard>
      </CopyInputWrapper>
    </div>
  );
};

export default CopyHiddenInput;
